class AnnouncementRotator extends HTMLElement {
  constructor() {
    super();
    this.items = Array.from(this.querySelectorAll('.announcement-rotator__item'));
    this.current = this.items.findIndex((item) => item.classList.contains('is-active'));
    if (this.current === -1) this.current = 0;

    this.interval = parseInt(this.dataset.interval, 10) || 2000;
    this.autoplay = this.dataset.autoplay === 'true';

    this.prevBtn = this.querySelector('.announcement-rotator__arrow--prev');
    this.nextBtn = this.querySelector('.announcement-rotator__arrow--next');

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.show(this.current - 1, 'down'));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.show(this.current + 1, 'up'));

    if (this.autoplay && this.items.length > 1) this.play();

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => { if (this.autoplay) this.play(); });
  }

  play() {
    this.pause();
    this.timer = setInterval(() => this.show(this.current + 1, 'up'), this.interval);
  }

  pause() {
    clearInterval(this.timer);
  }

  show(index, direction) {
    if (this.items.length < 2) return;
    const total = this.items.length;
    const nextIndex = ((index % total) + total) % total;
    if (nextIndex === this.current) return;

    const currentItem = this.items[this.current];
    const nextItem = this.items[nextIndex];

    currentItem.classList.remove('is-active');
    currentItem.classList.add(direction === 'up' ? 'is-leaving-up' : 'is-leaving-down');

    nextItem.classList.add(direction === 'up' ? 'is-entering-up' : 'is-entering-down');
    // Force reflow so the entering transform is applied before the active class swap.
    void nextItem.offsetWidth;
    nextItem.classList.add('is-active');

    window.setTimeout(() => {
      currentItem.classList.remove('is-leaving-up', 'is-leaving-down');
      nextItem.classList.remove('is-entering-up', 'is-entering-down');
    }, 600);

    this.current = nextIndex;
  }
}

customElements.define('announcement-rotator', AnnouncementRotator);
